// Colores consistentes por compañía en toda la app (Parte D). Se elige teal para Trébol en vez
// de verde para no chocar con el verde del semáforo de cobro (cobrado / al corriente).
export function companyColorKey(prefijoOrNumero) {
  const p = (prefijoOrNumero || "").toUpperCase();
  return p.startsWith("AL") ? "alvarez" : "trebol";
}

const CLASSES = {
  alvarez: "border border-blue-200 bg-blue-50 text-blue-700",
  trebol: "border border-teal-200 bg-teal-50 text-teal-700",
};

const LABELS = { alvarez: "Álvarez", trebol: "Trébol" };

export function companyChipClasses(prefijoOrNumero) {
  return CLASSES[companyColorKey(prefijoOrNumero)];
}

export function companyChipLabel(prefijoOrNumero) {
  return LABELS[companyColorKey(prefijoOrNumero)];
}
